import * as yup from "yup";

export function ValidateDocumentsTypes(listNature) {
    return yup.object().shape({
        name: yup.string().required("Nome é obrigatório").min(3, "Nome deve ter mais que três caracteres"),
        type_nature: yup.string().required("Tipo de pagamento é obrigatório").oneOf(listNature, "Tipo de pagamento inválido"),
    });
}
